import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';

export default [
  <Route key="/business/showcase/nail-color" element={<ShowocaseLayout />}>
    <Route path="business/showcase/nail-color" element={<AsyncPage />} />
  </Route>,
];
